import {BadgeDetailsContext} from '../context'
import useGetBrandsDropdown from '../hooks/useGetBrandsDropdown'
import BadgeDetailsForm from '../sections/forms/BadgeDetailsForm'
import useBadgeDetails from '../hooks/useBadgeDetails'
import useGetProductsDropdown from '../hooks/useGetProductsDropdown'
import useGetCategories from '../hooks/useGetCategories'
import useProductBadgesOperations from '../hooks/useProductBadgesOperations'
import usePermission from '../../../hook/usePermission'

const BadgeDetails = ({isEdit}: {isEdit: boolean}) => {
  const {badgeDetails, isLoading, filters, onSearch, onSortingChange} = useBadgeDetails()
  const {isOperationLoading, addProductBadge, updateProductBadge} = useProductBadgesOperations()
  const {allBrands, isLoading: isLoadingBrands} = useGetBrandsDropdown('')
  const {allCategories, isLoading: isLoadingCategories} = useGetCategories()
  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('products_product badges', 'write') || false

  const {
    allProducts,
    isLoading: isLoadingProducts,
    onPageChangeProducts,
    onSearchProducts,
    productPagination,
    refetchProducts,
  } = useGetProductsDropdown()

  const contextValue = {
    brands: allBrands,
    categories: allCategories,
    isLoadingBrands,
    isLoadingCategories,
    products: allProducts,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    isLoadingProducts,
    badgeDetails,
    onPageChangeProducts,
    onSearchProducts,
    productPagination,
    refetchProducts,

    addProductBadge,
    updateProductBadge,
    isOperationLoading,
    hasWritePermission,
  }

  return (
    <BadgeDetailsContext.Provider value={contextValue}>
      <BadgeDetailsForm isEdit={isEdit} />
    </BadgeDetailsContext.Provider>
  )
}

export default BadgeDetails
